import { render, staticRenderFns } from "./CampaignSelect.vue?vue&type=template&id=88b3b78e"
import script from "./CampaignSelect.vue?vue&type=script&lang=js"
export * from "./CampaignSelect.vue?vue&type=script&lang=js"
import style0 from "./CampaignSelect.vue?vue&type=style&index=0&id=88b3b78e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports